/**
 * Canonical site origin. The only source is VITE_SITE_URL (.env locally, a Docker build arg
 * in CI); deploy/site-url.sh swaps it per environment at container start. In the browser it
 * falls back to the current origin; on the server it is '' when unset (the build fails then).
 */
export function getSiteUrl(): string {
  const fromEnv = import.meta.env.VITE_SITE_URL?.replace(/\/+$/, '').trim();
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined') {
    return window.location.origin.replace(/\/+$/, '');
  }
  return '';
}

export function absoluteUrl(path: string): string {
  const base = getSiteUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
